import { Anchor, type _Navigation } from ":setup/qrouter";
import { default as routes } from "../routes";

export default function HelpCenter(props: _Navigation.SideNavJSXItemProps) {
  return (
    <Anchor
      class={props.anchor?.class}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      components={{
        title: "Help & FAQ",
        idleIcon: <i class="i-mdi:message-question-outline" />,
        activeIcon: <i class="i-mdi:message-question-outline" />,
      }}
    />
  );
}
